var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info"},_vm._l((_vm.items),function(item,index){return _c('FeedbackInput',{key:index,attrs:{"id":item.id,"placeholder":item.text,"text":_vm.data.values.find(function (it) { return it.id === item.id; })
        ? _vm.data.values.find(function (it) { return it.id === item.id; }).value
        : ''},on:{"updateValue":function($event){return _vm.update()}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }